const actionType = {
    GET_BR_RECORDS_SUCCESS: 'GET_BR_RECORDS_SUCCESS',
};
export default actionType;